<template>
    <div class="row">
        <div class="col-12">
            <div class="list-item-carousel owl-carousel owl-theme" ref="carouselContainer">
                <slot-component v-for="(item, index) in $slots.items" :key="index" :vnode="item"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        SlotComponent: {
            functional: true,
            render: (createElement, context) => context.data.attrs.vnode
        }
    },
    
    props: {
        itemsPerPage: {
            type: Number,
            default: 6
        },
        autoHeight: {
            type: Boolean,
            default: false
        }
    },
    
    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeCarousel();
        });
    },
    
    updated()
    {
        this.initializeCarousel();
    },
    
    methods:
    {
        initializeCarousel()
        {
            const $owl = $(this.$refs.carouselContainer);
            
            // do not render, if no html element is inside of the carousels container
            if (!$owl.children().length)
            {
                return;
            }
            
            $owl.owlCarousel({
                onInitialized()
                {
                    $owl.find(".owl-carousel.owl-loaded").each(function()
                    {
                        $(this).trigger("refresh.owl.carousel");
                    });
                },
                autoHeight: this.autoHeight,
                dots: false,
                items: this.itemsPerPage,
                lazyLoad: false,
                loop: false,
                margin: 15,
                mouseDrag: true,
                nav: true,
                responsive: {
                    0: {
                        items: 2,
                        slideBy: 2
                    },
                    // breakpoint from 544 up
                    544: {
                        items: 2,
                        slideBy: 2
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 4,
                        slideBy: 1
                    },
                    1025: {
                        items: 6,
                        slideBy: 1
                    }
                },
                navClass: [
                    "owl-single-item-nav left carousel-control list-control-special",
                    "owl-single-item-nav right carousel-control list-control-special"
                ],
                navContainerClass: "",
                navText: [
                    "<i class=\"owl-single-item-control fa fa-chevron-left\" aria-hidden=\"true\"></i>",
                    "<i class=\"owl-single-item-control fa fa-chevron-right\" aria-hidden=\"true\"></i>"
                ],
                smartSpeed: 350
            });
        }
    }
}
</script>
